import Analytics from "components/analytics";
import Cookies from "js-cookie";
import React from "react";
import styled from "styled-components";

export const CookieBanner = ({ children }) => {
	const [isAccepted, setIsAccepted] = React.useState(false);

	const acceptedCookie = Boolean(Cookies.get("cookie-banner-accepted"));

	if (acceptedCookie || isAccepted) {
		return <Analytics>{children}</Analytics>;
	}

	const accept = () => {
		Cookies.set("cookie-banner-accepted", true, { expires: 30 });
		setIsAccepted(true);
	};

	return (
		<>
			{children}
			<Wrap>
				<p>
					This website uses cookies to ensure the best experience.{" "}
					<Link
						href="https://www.cookiesandyou.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						Learn more
					</Link>
				</p>
				<Button type="button" onClick={accept}>
					OK
				</Button>
			</Wrap>
		</>
	);
};

const Wrap = styled.div`
  align-items: center;
  background-color: #000;
  bottom: 0;
  color: #fff;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: 1rem;
  position: fixed;
  right: 0;
  text-align: center;
  z-index: 1000;
`;

const Link = styled.a`
  color: #fff;
  text-decoration: underline;
`;

const Button = styled.button`
  background-color: #fff;
  border: 0;
  color: #000;
  cursor: pointer;
  font-weight: 500;
  letter-spacing: 1px;
  outline: none;
  padding: 0.5rem 2rem;
  text-transform: uppercase;

  &:hover {
    opacity: 0.75;
  }

  &:active {
    opacity: 1;
  }
`;
